// extracted by mini-css-extract-plugin
export default {"textSlot":"dfkpbDSv1g3xnfTQtV4z","items":"LGO4Ip2kazt6RJ_4bNks","divider":"b_zwHN6gjsvoUjoQJJxc"};